if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.imageElement = this.querySelector('[data-media-modal-image]');
      }

      hide() {
        super.hide();
        // 清空图片，下次打开时重新加载
        if (this.imageElement) {
          this.imageElement.src = '';
          this.imageElement.alt = '';
        }
      }

      show(opener) {
        // 从点击的按钮获取图片信息
        const mediaContainer = opener.closest('.product-media-container');
        const img = mediaContainer?.querySelector('img');
        
        if (img && this.imageElement) {
          // 使用高清原图
          const highResUrl = img.src.replace(/width=\d+/, 'width=2048');
          this.imageElement.src = highResUrl;
          this.imageElement.alt = img.alt;
          this.imageElement.width = img.naturalWidth || 2048;
          this.imageElement.height = img.naturalHeight || 2048;
        }

        super.show(opener);
      }

      showActiveMedia() {
        // 单张图片模式，不需要切换逻辑
        // 图片已在 show() 中设置
      }
    }
  );
}